module.exports = __webpack_public_path__ + "static/media/card-twitter.283e0787.jpg";